import React from 'react';
import './HighlightCard.css';

const HighlightCard = ({
  children,
  width = '900px',
  height = '100%',
  padding = '10px',
  alignItems = 'center',
  gap = '10px',
  justifyContent = 'space-evenly',
  flexDirection = 'row',
  marginTop = '20px',
}) => {
  return (
    <div className="cards__inner">
      <div
        className="cards__card card"
        style={{
          width,
          height,
          padding,
          alignItems,
          gap,
          justifyContent,
          flexDirection,
          marginTop,
          display: 'flex',
        }}
      >
        {children}
      </div>
      <div className="overlay cards__inner" />
    </div>
  );
};

export default HighlightCard;
